import { render, staticRenderFns } from "./VariantSelector.vue?vue&type=template&id=0b6a6e7d&scoped=true&"
import script from "./VariantSelector.vue?vue&type=script&lang=js&"
export * from "./VariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./VariantSelector.vue?vue&type=style&index=0&id=0b6a6e7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a6e7d",
  null
  
)

export default component.exports